import { ListItem, ListItemButton, Theme, SxProps } from '@mui/material'

interface Props {
  onClick?: React.MouseEventHandler<HTMLLIElement>
  children: React.ReactNode
  menuAnchorId?: string
  baseSx?: SxProps<Theme>
  sx?: SxProps<Theme>
}

function CardListItem(props: Props) {
  const { menuAnchorId, onClick, children, sx } = props
  return (
    <ListItem
      disablePadding
      onClick={onClick}
      sx={{
        pointerEvents: onClick ? 'auto' : 'none',
        backgroundColor: (theme) => theme.palette.background.paper, // Needed for when used as a draggable item
        '& .MuiButtonBase-root.MuiListItemButton-root': {
          transition: 'all 0.3s ease-in-out',
          py: 2.5,
          ...(props.baseSx || {}),
        },
        ...(onClick && {
          '&:hover .MuiButtonBase-root': {
            '@media (hover: hover)': { // This only applies the hover styles if :hover is supported, e.g. not on touch devices
              backgroundColor: (theme) => theme.palette.secondary.light,
            },
          },
        }),
        ...(onClick && {
          '&:active .MuiButtonBase-root': {
            transition: 'none',
            backgroundColor: (theme) => theme.palette.secondary.main,
          },
        }),
        ...(sx || {}),
      } as SxProps<Theme>}
      id={menuAnchorId}
    >
      <ListItemButton disableRipple sx={{ gap: 2 }}>
        {children}
      </ListItemButton>
    </ListItem>
  )
}

export default CardListItem
